import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminService from "../../services/AdminService";
import Modal from "react-modal";

const initialRequestData = [
  {
    iin: "940512345678",
    bin: "123456789012",
    company: "ООО Альфа",
    informationSystem: "Система учёта Alpha",
    number: "+77051234567",
    email: "contact@alpha.com",
    moduleName: "AlphaModule",
    moduleVersion: "1.0.0",
    moduleDescription: "Модуль для системы Alpha",
    moduleFunctions: "Аутентификация, обработка данных",
    moduleChecksum: "abc123checksum",
    moduleURL: "https://alpha.com/module",
    moduleIsolation: true,
    moduleFileAttachment: "alpha_module_v1.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "NEW",
  },
  {
    iin: "920811234567",
    bin: "987654321098",
    company: "ТОО Бета",
    informationSystem: "Система учёта Beta",
    number: "+77069876543",
    email: "info@beta.kz",
    moduleName: "BetaModule",
    moduleVersion: "2.3.4",
    moduleDescription: "Обновление модуля Beta",
    moduleFunctions: "Валидация данных, отчёты",
    moduleChecksum: "def456checksum",
    moduleURL: "https://beta.kz/module",
    moduleIsolation: false,
    moduleFileAttachment: "beta_module_v2.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "NEW",
  },
  {
    iin: "981231234567",
    bin: "654321098765",
    company: "АО Гамма",
    informationSystem: "Система учёта Gamma",
    number: "+77079876543",
    email: "support@gamma.com",
    moduleName: "GammaModule",
    moduleVersion: "3.0.0",
    moduleDescription: "Модуль интеграции Gamma",
    moduleFunctions: "Интеграция с API",
    moduleChecksum: "ghi789checksum",
    moduleURL: "https://gamma.com/module",
    moduleIsolation: true,
    moduleFileAttachment: "gamma_module_v3.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "NEW",
  },
  {
    iin: "960712345678",
    bin: "321098765432",
    company: "ТОО Дельта",
    informationSystem: "Система учёта Delta",
    number: "+77061234567",
    email: "delta@service.kz",
    moduleName: "DeltaModule",
    moduleVersion: "1.2.0",
    moduleDescription: "Обновление модуля Delta",
    moduleFunctions: "Верификация данных, отчёты",
    moduleChecksum: "jkl012checksum",
    moduleURL: "https://delta.kz/module",
    moduleIsolation: false,
    moduleFileAttachment: "delta_module_v1.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "NEW",
  },
  {
    iin: "951231234567",
    bin: "012345678901",
    company: "ООО Эпсилон",
    informationSystem: "Система учёта Epsilon",
    number: "+77078889900",
    email: "epsilon@corporate.kz",
    moduleName: "EpsilonModule",
    moduleVersion: "4.5.6",
    moduleDescription: "Модуль для системы Epsilon",
    moduleFunctions: "Формирование отчётов, статистика",
    moduleChecksum: "mno345checksum",
    moduleURL: "https://epsilon.kz/module",
    moduleIsolation: true,
    moduleFileAttachment: "epsilon_module_v4.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "REJECTED",
  },
  {
    iin: "930412345678",
    bin: "876543210987",
    company: "АО Зета",
    informationSystem: "Система учёта Zeta",
    number: "+77051239876",
    email: "zeta@info.kz",
    moduleName: "ZetaModule",
    moduleVersion: "0.9.1",
    moduleDescription: "Бета-версия модуля Zeta",
    moduleFunctions: "Тестирование, API интеграция",
    moduleChecksum: "pqr678checksum",
    moduleURL: "https://zeta.kz/module",
    moduleIsolation: false,
    moduleFileAttachment: "zeta_module_beta.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "CONFIRMED",
  },
  {
    iin: "930412345678",
    bin: "876543210987",
    company: "АО Зета",
    informationSystem: "Система учёта Zeta",
    number: "+77051239876",
    email: "zeta@info.kz",
    moduleName: "ZetaModule",
    moduleVersion: "0.9.1",
    moduleDescription: "Бета-версия модуля Zeta",
    moduleFunctions: "Тестирование, API интеграция",
    moduleChecksum: "pqr678checksum",
    moduleURL: "https://zeta.kz/module",
    moduleIsolation: false,
    moduleFileAttachment: "zeta_module_beta.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "CONFIRMED",
  },
  {
    iin: "930412345678",
    bin: "876543210987",
    company: "АО Зета",
    informationSystem: "Система учёта Zeta",
    number: "+77051239876",
    email: "zeta@info.kz",
    moduleName: "ZetaModule",
    moduleVersion: "0.9.1",
    moduleDescription: "Бета-версия модуля Zeta",
    moduleFunctions: "Тестирование, API интеграция",
    moduleChecksum: "pqr678checksum",
    moduleURL: "https://zeta.kz/module",
    moduleIsolation: false,
    moduleFileAttachment: "zeta_module_beta.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "CONFIRMED",
  },
  {
    iin: "930412345678",
    bin: "876543210987",
    company: "АО Зета",
    informationSystem: "Система учёта Zeta",
    number: "+77051239876",
    email: "zeta@info.kz",
    moduleName: "ZetaModule",
    moduleVersion: "0.9.1",
    moduleDescription: "Бета-версия модуля Zeta",
    moduleFunctions: "Тестирование, API интеграция",
    moduleChecksum: "pqr678checksum",
    moduleURL: "https://zeta.kz/module",
    moduleIsolation: false,
    moduleFileAttachment: "zeta_module_beta.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "CONFIRMED",
  },
  {
    iin: "930412345678",
    bin: "876543210987",
    company: "АО Зета",
    informationSystem: "Система учёта Zeta",
    number: "+77051239876",
    email: "zeta@info.kz",
    moduleName: "ZetaModule",
    moduleVersion: "0.9.1",
    moduleDescription: "Бета-версия модуля Zeta",
    moduleFunctions: "Тестирование, API интеграция",
    moduleChecksum: "pqr678checksum",
    moduleURL: "https://zeta.kz/module",
    moduleIsolation: false,
    moduleFileAttachment: "zeta_module_beta.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "CONFIRMED",
  },
  {
    iin: "930412345678",
    bin: "876543210987",
    company: "АО Зета",
    informationSystem: "Система учёта Zeta",
    number: "+77051239876",
    email: "zeta@info.kz",
    moduleName: "ZetaModule",
    moduleVersion: "0.9.1",
    moduleDescription: "Бета-версия модуля Zeta",
    moduleFunctions: "Тестирование, API интеграция",
    moduleChecksum: "pqr678checksum",
    moduleURL: "https://zeta.kz/module",
    moduleIsolation: false,
    moduleFileAttachment: "zeta_module_beta.zip",
    dateCreate: "08.11.2024, 15:14:25",
    moduleStatus: "CONFIRMED",
  },
];

const AdminNCALayerModuleRequests = () => {
  Modal.setAppElement("#root");
  const { t } = useTranslation();
  const [userError, setUserError] = useState(null);
  const [requestData, setRequestData] = useState(initialRequestData);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4; // Количество элементов на странице
  const navigate = useNavigate();

  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false); // Состояние для модального окна
  const [rejectReason, setRejectReason] = useState(""); // Состояние для причины отказа
  const [selectedRequestId, setSelectedRequestId] = useState(null); // Для хранения id заявки

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = requestData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(requestData.length / itemsPerPage);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const requests = await AdminService.getNCALayerModuleRequests();
      console.log(requests);
      setRequestData(requests.data);
    } catch (error) {
      console.error(error);
      if (error.response?.data?.status === 403) {
        navigate("/nm-auth", {
          replace: true,
        });
      }
    }
  };

  const openRejectModal = (requestId) => {
    console.log("Открытие модального окна для заявки");
    setSelectedRequestId(requestId);
    setIsRejectModalOpen(true);
    
  };

  const handleReject = async () => {
    try {
      await AdminService.rejectRequest(selectedRequestId, rejectReason);
      setIsRejectModalOpen(false);
      fetchData(); // Обновление данных после отклонения
    } catch (error) {
      console.error("Ошибка при отклонении заявки", error);
    }
  };
  const handleConfirm = async (requestId) =>  {
    try {
      await AdminService.confirmRequest(requestId);
      fetchData();
    } catch(e) {
      console.error(e);
    }
    
  };

  const handleClose = async (requestId) => {
    try{
      await AdminService.closeRequest(requestId);
      fetchData();
    } catch(e) {
      console.error(e);
    } 
  };

  const handleSort = (key) => {
    const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    const sortedData = [...requestData].sort((a, b) => {
      if (key === "date") {
        const parseDate = (dateArray) => {
          if (Array.isArray(dateArray) && dateArray.length >= 6) {
            return new Date(
              dateArray[0], 
              dateArray[1] - 1, 
              dateArray[2], 
              dateArray[3], 
              dateArray[4], 
              dateArray[5] 
            );
          }
          return new Date(0); 
        };
    
        const dateA = parseDate(a.dateCreate);
        const dateB = parseDate(b.dateCreate);
    
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }
      if (key === "status") {
        const statusA = statusOrder[a.moduleStatus] || statusOrder["UNKNOWN"];
        const statusB = statusOrder[b.moduleStatus] || statusOrder["UNKNOWN"];
        if (statusA === statusB) return 0;
        return direction === "asc" ? statusA - statusB : statusB - statusA;
      }
      return 0;
    });

    setSortConfig({ key, direction });
    setRequestData(sortedData);
  };

  const statusOrder = {
    NEW: 1,
    IN_PROGRESS: 2,
    REJECTED: 3,
    COMPLETED: 4,
    UNKNOWN: 5,
  };
  const mapStatus = (status) => {
    switch (status) {
      case "NEW":
        return "Новая";
      case "IN_PROGRESS":
        return "Подтверждена";
      case "REJECTED":
        return "Отклонена";
      case "COMPLETED":
        return "Закрыта";
      default:
        return "Неизвестный статус";
    }
  };

  const formatDate = (dateArray) => { 
    if (Array.isArray(dateArray) && dateArray.length >= 6) {
      const date = new Date(
        dateArray[0], // Год
        dateArray[1] - 1, // Месяц (индексируется с 0)
        dateArray[2] ,// День
        dateArray[3], // Часы
        dateArray[4], // Минуты
        dateArray[5] // Секунды
      );
      return date.toLocaleString();
    }
    return "Неверный формат даты";
  };
  
  const handlePageChange = (event, pageNumber) => {
    event.preventDefault(); // Предотвращает перезагрузку страницы
    setCurrentPage(pageNumber);
  };

  return (
    <div className="content">
      <div className="titleCell">
        <span>{t("NCALayerModuleForm.adminModuleTitle")}</span>
      </div>
      <Modal
        isOpen={isRejectModalOpen}
        onRequestClose={() => setIsRejectModalOpen(false)}
        contentLabel="Причина отказа"
        className="myModal"
        overlayClassName="myOverlay"
      >
        <div className="modalTitle">Введите причину отказа</div>
        <textarea
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
          rows="4"
          cols="50"
          placeholder="Причина отказа"
        />
        <div></div>
        <div>
          <button onClick={handleReject} className="new-red-btn">
          {t("general.reject")}
          </button>
          <button
            onClick={() => setIsRejectModalOpen(false)}
            className="new-blue-btn"
          >
           {t("general.cancel")}
          </button>
        </div>
      </Modal>
      <form id="indexForm" className="indexForm">
        <div className="sortButtonsContainer">
          <button
            type="button"
            className={`sortButton ${
              sortConfig.key === "date" ? "active" : ""
            }`}
            onClick={() => handleSort("date")}
          >
            {t("NCALayerModuleForm.sortDate")}
            <span
              className={`sortIcon ${
                sortConfig.key === "date" && sortConfig.direction === "asc"
                  ? "asc"
                  : "desc"
              }`}
            >
              {sortConfig.key === "date"
                ? sortConfig.direction === "asc"
                  ? "↑"
                  : "↓"
                : ""}
            </span>
          </button>

          <button
            type="button"
            className={`sortButton ${
              sortConfig.key === "status" ? "active" : ""
            }`}
            onClick={() => handleSort("status")}
          >
            {t("NCALayerModuleForm.sortStatus")}
            <span
              className={`sortIcon ${
                sortConfig.key === "status" && sortConfig.direction === "asc"
                  ? "asc"
                  : "desc"
              }`}
            >
              {sortConfig.key === "status"
                ? sortConfig.direction === "asc"
                  ? "↑"
                  : "↓"
                : ""}
            </span>
          </button>
        </div>

        <div
          id="paginatorDataTabel"
          className="ui-datatable ui-widget hide-column-names"
        >
          <div className="ui-datatable-tablewrapper">
            <table className="nm-table" role="grid">
              <tbody
                id="paginatorDataTabel_data"
                className="ui-datatable-data ui-widget-content"
              >
                {currentItems.map((data, index) => (
                  <tr
                    key={index}
                    className="ui-widget-content ui-datatable-even nm-datatable"
                  >
                    <td role="gridcell">
                      <table
                        className="float-left cellPadding_5"
                        cellPadding="5"
                      >
                        <tbody>
                          {Object.entries({
                            [t("NCALayerModuleForm.moduleDateCreate")]:
                              formatDate(data.dateCreate),
                            [t("SDKUserForm.iin")]: data.iin,
                            [t("SDKUserForm.bin")]: data.bin,
                            [t("SDKUserForm.organizationName")]: data.company,
                            [t("SDKUserForm.informationSystem")]:
                              data.informationSystem,
                            [t("SDKUserForm.phoneNumber")]: data.number,
                            [t("NCALayerModuleForm.moduleEmail")]: data.email,
                            [t("NCALayerModuleForm.moduleName")]:
                              data.moduleName,
                            [t("NCALayerModuleForm.moduleVersion")]:
                              data.moduleVersion,
                            [t("NCALayerModuleForm.moduleDescription")]:
                              data.moduleDescription,
                            [t("NCALayerModuleForm.moduleFunctions")]:
                              data.moduleFunctions,
                            [t("NCALayerModuleForm.moduleChecksum")]:
                              data.moduleCheckSum,
                            [t("NCALayerModuleForm.moduleURL")]: (
                              <a
                                href={data.moduleURL}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {data.moduleURL}
                              </a>
                            ),
                            [t("NCALayerModuleForm.moduleIsolation")]:
                              data.moduleIsolation ? "Да" : "Нет",
                  
                            [t("NCALayerModuleForm.moduleStatus")]: mapStatus(
                              data.moduleStatus
                            ),
                          }).map(([label, value]) => (
                            <tr key={label}>
                              <td className="ccLeft ccInfoLeft nm-ccLeft-width">
                                <span className="info-label">{label}:</span>
                              </td>
                              <td className="ccRight ccInfoRight nm-ccRight-width">
                                {value}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="nm-admin-buttons-div">
                        {data.moduleStatus === "IN_PROGRESS" ? (
                          <input
                            type="button"
                            onClick={() => handleClose(data.id)}
                            value={t("NmAdmin.closing")}
                            className="new-blue-btn"
                          />
                        ) : data.moduleStatus === "NEW" ? (
                          <>
                            <input
                              type="button"
                              onClick={() => handleConfirm(data.id)}
                              value={t("NmAdmin.confirming")}
                              className="new-blue-btn"
                            />
                            <input
                              type="button"
                              onClick={() => openRejectModal(data.id)}
                              value={t("NmAdmin.closing")}
                              className="new-red-btn"
                            />
                          </>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* Пагинация */}
        <div className="pagination">
          <button
            onClick={(e) => {
              e.preventDefault();
              setCurrentPage((prev) => Math.max(prev - 1, 1));
            }}
            disabled={currentPage === 1}
          >
           {t("general.previous")}
          </button>

          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={currentPage === index + 1 ? "active" : ""}
              onClick={(event) => handlePageChange(event, index + 1)}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={(e) => {
              e.preventDefault();
              setCurrentPage((prev) => Math.min(prev + 1, totalPages));
            }}
            disabled={currentPage === totalPages}
          >
            {t("general.next")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminNCALayerModuleRequests;